import { GridRenderCellParams } from '@mui/x-data-grid';
import { t } from 'i18next';
import { useContext, useState } from 'react';

import DatagridWrapper, { DataGridId } from '../../components/DatagridWrapper';
import { NotCorrectRights } from '../Permission/NotCorrectRights';
import { AbilityContext, Can } from '../UserApi/logic/Can';

import { History } from '@mui/icons-material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta, QueryDefinition } from '@reduxjs/toolkit/dist/query';
import { UseQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import InfoButton from '../../components/InfoButton';
import InfoDrawer from '../../components/InfoDrawer';
import { OrganisationContext } from '../../components/Layout/OrganisationPicker';
import { OpenInNewTabButton } from '../../components/OpenInNewTabButton';
import { PaginationQueryPackage } from '../../models/API/QueryParams/PaginationQueryPackage';
import { ContactResponse } from '../../models/Contact';
import { GetManyPackage } from '../../redux/GetManyPackage';
import { PermissionEnum } from '../Permission/PermissionEnum';
import { ExternalContactInfoDialog } from './externalContactInfoButton/ExternalContactInfoDialog';

const getCurrentContact = (contacts: ContactResponse[], params: GridRenderCellParams<any, any, any>): ContactResponse => {
    const contact = contacts.find(x => x.uuid === params.id)!;
    return contact;
}

class ExternalContactListProps {
    getExternalContacts!: UseQuery<QueryDefinition<GetManyPackage, BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, object, FetchBaseQueryMeta>, any, ContactResponse[], any>>
    idToFetch?: string
    simpleView?: boolean = false;
}

export const ExternalContactList = (props: ExternalContactListProps) => {
    const ability = useContext(AbilityContext);
    const organisationContext = useContext(OrganisationContext)?.organisation
    const canReadList = ability.can(PermissionEnum.EXTERNAL_CONTACT_READ, organisationContext)
    if (!canReadList)
        return <NotCorrectRights />

    return (<ExternalContactListContent {...props} />)
}

export const ExternalContactListContent = (props: ExternalContactListProps) => {


    const currentResult = props.getExternalContacts({
        pagination: new PaginationQueryPackage(),
        uuid: props.idToFetch
    })

    const [clickedRow, setClickedRow] = useState<ContactResponse | undefined>(undefined)

    if (currentResult.data === undefined)
        currentResult.data = []


    const getColumns = (contacts: ContactResponse[]) => {

        const columns: GridColDef[] = [
            { field: "name", sortable: true, type: "string", headerName: t('Name'), valueGetter: (_, row: ContactResponse) => row.first_name + " " + row.last_name, flex: 1 },
            { field: "email", sortable: true, type: "string", headerName: t('Email'), flex: 1 },
            {field: "phone", sortable: true, type: "string", headerName: t('Phone'), flex: 1},
            {
                field: 'events',
                sortable: false,
                hideable: false,
                type: "string",
                headerName: t('Actions'),
                minWidth: props.simpleView ? 100 : 220,
                renderCell: (params => {
                    const contact = getCurrentContact(contacts, params)
                    return (props.simpleView ?
                        <OpenInNewTabButton url={`/contacts/${contact.uuid}`} />
                        :
                        <>
                            <Can I={PermissionEnum.EXTERNAL_CONTACT_READ} this={contact}>
                                <InfoButton onClick={() => setClickedRow(contact)} />
                            </Can>
                            <Can I={PermissionEnum.AUDIT_READ} this={contact}>
                                <OpenInNewTabButton tooltipText='Events' icon={<History />} url={`/events?entity_uuid=${contact.uuid}`} />
                            </Can>
                            <Can I={PermissionEnum.EXTERNAL_CONTACT_READ} this={contact}>
                                <OpenInNewTabButton url={`/contacts/${contact.uuid}`} />
                            </Can>
                        </>
                    )
                })
            }
        ];
        return columns
    }

    return (
        <>
            <DatagridWrapper
                dataGridId={DataGridId.EXTERNAL_CONTACTS}
                onRowClick={(row) => { setClickedRow(row.row) }}
                loading={currentResult.isLoading}
                rows={currentResult.data}
                columns={getColumns(currentResult.data)}
            />

            <InfoDrawer
                open={clickedRow != undefined}
                onClose={() => setClickedRow(undefined)}
                entityUuid={clickedRow?.uuid}>
                {clickedRow &&
                    <ExternalContactInfoDialog
                        key={clickedRow.uuid}
                        uuid={clickedRow.uuid}
                        afterDeleteAction={() => setClickedRow(undefined)} />}
            </InfoDrawer>
        </>
    )
}

